/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  TermsAndConditionsDTO,
  TermsAndConditionsType
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getAllTermsAndConditions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO[]>(
      {url: `/api/terms-and-conditions`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAllTermsAndConditionsQueryKey = () => {
    return [`/api/terms-and-conditions`] as const;
    }

    
export const getGetAllTermsAndConditionsQueryOptions = <TData = Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllTermsAndConditionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllTermsAndConditions>>> = ({ signal }) => getAllTermsAndConditions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllTermsAndConditionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllTermsAndConditions>>>
export type GetAllTermsAndConditionsQueryError = unknown


export function useGetAllTermsAndConditions<TData = Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTermsAndConditions>>,
          TError,
          Awaited<ReturnType<typeof getAllTermsAndConditions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllTermsAndConditions<TData = Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllTermsAndConditions>>,
          TError,
          Awaited<ReturnType<typeof getAllTermsAndConditions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllTermsAndConditions<TData = Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllTermsAndConditions<TData = Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllTermsAndConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllTermsAndConditionsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const updateTermsAndConditions = (
    termsAndConditionsDTO: TermsAndConditionsDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<TermsAndConditionsDTO>(
      {url: `/api/terms-and-conditions`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: termsAndConditionsDTO
    },
      options);
    }
  


export const getUpdateTermsAndConditionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTermsAndConditions>>, TError,{data: TermsAndConditionsDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateTermsAndConditions>>, TError,{data: TermsAndConditionsDTO}, TContext> => {

const mutationKey = ['updateTermsAndConditions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateTermsAndConditions>>, {data: TermsAndConditionsDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateTermsAndConditions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateTermsAndConditionsMutationResult = NonNullable<Awaited<ReturnType<typeof updateTermsAndConditions>>>
    export type UpdateTermsAndConditionsMutationBody = TermsAndConditionsDTO
    export type UpdateTermsAndConditionsMutationError = unknown

    export const useUpdateTermsAndConditions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateTermsAndConditions>>, TError,{data: TermsAndConditionsDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateTermsAndConditions>>,
        TError,
        {data: TermsAndConditionsDTO},
        TContext
      > => {

      const mutationOptions = getUpdateTermsAndConditionsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const createTermsAndConditions = (
    termsAndConditionsDTO: TermsAndConditionsDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO>(
      {url: `/api/terms-and-conditions`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: termsAndConditionsDTO, signal
    },
      options);
    }
  


export const getCreateTermsAndConditionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTermsAndConditions>>, TError,{data: TermsAndConditionsDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createTermsAndConditions>>, TError,{data: TermsAndConditionsDTO}, TContext> => {

const mutationKey = ['createTermsAndConditions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createTermsAndConditions>>, {data: TermsAndConditionsDTO}> = (props) => {
          const {data} = props ?? {};

          return  createTermsAndConditions(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateTermsAndConditionsMutationResult = NonNullable<Awaited<ReturnType<typeof createTermsAndConditions>>>
    export type CreateTermsAndConditionsMutationBody = TermsAndConditionsDTO
    export type CreateTermsAndConditionsMutationError = unknown

    export const useCreateTermsAndConditions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createTermsAndConditions>>, TError,{data: TermsAndConditionsDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createTermsAndConditions>>,
        TError,
        {data: TermsAndConditionsDTO},
        TContext
      > => {

      const mutationOptions = getCreateTermsAndConditionsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const deactivateTermsAndConditions = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO>(
      {url: `/api/terms-and-conditions/${id}/deactivate`, method: 'POST', signal
    },
      options);
    }
  


export const getDeactivateTermsAndConditionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateTermsAndConditions>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deactivateTermsAndConditions>>, TError,{id: string}, TContext> => {

const mutationKey = ['deactivateTermsAndConditions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deactivateTermsAndConditions>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deactivateTermsAndConditions(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeactivateTermsAndConditionsMutationResult = NonNullable<Awaited<ReturnType<typeof deactivateTermsAndConditions>>>
    
    export type DeactivateTermsAndConditionsMutationError = unknown

    export const useDeactivateTermsAndConditions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deactivateTermsAndConditions>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deactivateTermsAndConditions>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeactivateTermsAndConditionsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const archiveTermsAndConditions = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<string>(
      {url: `/api/terms-and-conditions/${id}/archive`, method: 'POST', signal
    },
      options);
    }
  


export const getArchiveTermsAndConditionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveTermsAndConditions>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof archiveTermsAndConditions>>, TError,{id: string}, TContext> => {

const mutationKey = ['archiveTermsAndConditions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof archiveTermsAndConditions>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  archiveTermsAndConditions(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ArchiveTermsAndConditionsMutationResult = NonNullable<Awaited<ReturnType<typeof archiveTermsAndConditions>>>
    
    export type ArchiveTermsAndConditionsMutationError = unknown

    export const useArchiveTermsAndConditions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof archiveTermsAndConditions>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof archiveTermsAndConditions>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getArchiveTermsAndConditionsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const activateTermsAndConditions = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO>(
      {url: `/api/terms-and-conditions/${id}/activate`, method: 'POST', signal
    },
      options);
    }
  


export const getActivateTermsAndConditionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateTermsAndConditions>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof activateTermsAndConditions>>, TError,{id: string}, TContext> => {

const mutationKey = ['activateTermsAndConditions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof activateTermsAndConditions>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  activateTermsAndConditions(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ActivateTermsAndConditionsMutationResult = NonNullable<Awaited<ReturnType<typeof activateTermsAndConditions>>>
    
    export type ActivateTermsAndConditionsMutationError = unknown

    export const useActivateTermsAndConditions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof activateTermsAndConditions>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof activateTermsAndConditions>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getActivateTermsAndConditionsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getTermsAndConditions = (
    id: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO>(
      {url: `/api/terms-and-conditions/${id}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTermsAndConditionsQueryKey = (id?: string,) => {
    return [`/api/terms-and-conditions/${id}`] as const;
    }

    
export const getGetTermsAndConditionsQueryOptions = <TData = Awaited<ReturnType<typeof getTermsAndConditions>>, TError = unknown>(id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTermsAndConditionsQueryKey(id);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTermsAndConditions>>> = ({ signal }) => getTermsAndConditions(id, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(id), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTermsAndConditionsQueryResult = NonNullable<Awaited<ReturnType<typeof getTermsAndConditions>>>
export type GetTermsAndConditionsQueryError = unknown


export function useGetTermsAndConditions<TData = Awaited<ReturnType<typeof getTermsAndConditions>>, TError = unknown>(
 id: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTermsAndConditions>>,
          TError,
          Awaited<ReturnType<typeof getTermsAndConditions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTermsAndConditions<TData = Awaited<ReturnType<typeof getTermsAndConditions>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTermsAndConditions>>,
          TError,
          Awaited<ReturnType<typeof getTermsAndConditions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTermsAndConditions<TData = Awaited<ReturnType<typeof getTermsAndConditions>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetTermsAndConditions<TData = Awaited<ReturnType<typeof getTermsAndConditions>>, TError = unknown>(
 id: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTermsAndConditionsQueryOptions(id,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const deleteTermsAndConditions = (
    id: string,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<string>(
      {url: `/api/terms-and-conditions/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteTermsAndConditionsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTermsAndConditions>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteTermsAndConditions>>, TError,{id: string}, TContext> => {

const mutationKey = ['deleteTermsAndConditions'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteTermsAndConditions>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  deleteTermsAndConditions(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteTermsAndConditionsMutationResult = NonNullable<Awaited<ReturnType<typeof deleteTermsAndConditions>>>
    
    export type DeleteTermsAndConditionsMutationError = unknown

    export const useDeleteTermsAndConditions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteTermsAndConditions>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteTermsAndConditions>>,
        TError,
        {id: string},
        TContext
      > => {

      const mutationOptions = getDeleteTermsAndConditionsMutationOptions(options);

      return useMutation(mutationOptions , queryClient);
    }
    export const getTermsAndConditionsByType = (
    type: TermsAndConditionsType,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO[]>(
      {url: `/api/terms-and-conditions/type/${type}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTermsAndConditionsByTypeQueryKey = (type?: TermsAndConditionsType,) => {
    return [`/api/terms-and-conditions/type/${type}`] as const;
    }

    
export const getGetTermsAndConditionsByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError = unknown>(type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTermsAndConditionsByTypeQueryKey(type);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTermsAndConditionsByType>>> = ({ signal }) => getTermsAndConditionsByType(type, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(type), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTermsAndConditionsByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getTermsAndConditionsByType>>>
export type GetTermsAndConditionsByTypeQueryError = unknown


export function useGetTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTermsAndConditionsByType>>,
          TError,
          Awaited<ReturnType<typeof getTermsAndConditionsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTermsAndConditionsByType>>,
          TError,
          Awaited<ReturnType<typeof getTermsAndConditionsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTermsAndConditionsByTypeQueryOptions(type,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getLatestActiveTermsAndConditionsByType = (
    type: TermsAndConditionsType,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO>(
      {url: `/api/terms-and-conditions/type/${type}/latest`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLatestActiveTermsAndConditionsByTypeQueryKey = (type?: TermsAndConditionsType,) => {
    return [`/api/terms-and-conditions/type/${type}/latest`] as const;
    }

    
export const getGetLatestActiveTermsAndConditionsByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError = unknown>(type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestActiveTermsAndConditionsByTypeQueryKey(type);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>> = ({ signal }) => getLatestActiveTermsAndConditionsByType(type, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(type), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLatestActiveTermsAndConditionsByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>>
export type GetLatestActiveTermsAndConditionsByTypeQueryError = unknown


export function useGetLatestActiveTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>,
          TError,
          Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLatestActiveTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>,
          TError,
          Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLatestActiveTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLatestActiveTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLatestActiveTermsAndConditionsByTypeQueryOptions(type,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getTermsAndConditionsByTypeAndEntityId = (
    type: TermsAndConditionsType,
    entityId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO[]>(
      {url: `/api/terms-and-conditions/type/${type}/entity/${entityId}`, method: 'GET', signal
    },
      options);
    }
  

export const getGetTermsAndConditionsByTypeAndEntityIdQueryKey = (type?: TermsAndConditionsType,
    entityId?: string,) => {
    return [`/api/terms-and-conditions/type/${type}/entity/${entityId}`] as const;
    }

    
export const getGetTermsAndConditionsByTypeAndEntityIdQueryOptions = <TData = Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError = unknown>(type: TermsAndConditionsType,
    entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTermsAndConditionsByTypeAndEntityIdQueryKey(type,entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>> = ({ signal }) => getTermsAndConditionsByTypeAndEntityId(type,entityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(type && entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTermsAndConditionsByTypeAndEntityIdQueryResult = NonNullable<Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>>
export type GetTermsAndConditionsByTypeAndEntityIdQueryError = unknown


export function useGetTermsAndConditionsByTypeAndEntityId<TData = Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError = unknown>(
 type: TermsAndConditionsType,
    entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>,
          TError,
          Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTermsAndConditionsByTypeAndEntityId<TData = Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError = unknown>(
 type: TermsAndConditionsType,
    entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>,
          TError,
          Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTermsAndConditionsByTypeAndEntityId<TData = Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError = unknown>(
 type: TermsAndConditionsType,
    entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetTermsAndConditionsByTypeAndEntityId<TData = Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError = unknown>(
 type: TermsAndConditionsType,
    entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTermsAndConditionsByTypeAndEntityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTermsAndConditionsByTypeAndEntityIdQueryOptions(type,entityId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getLatestActiveTermsAndConditionsByTypeAndEntityId = (
    type: TermsAndConditionsType,
    entityId: string,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO>(
      {url: `/api/terms-and-conditions/type/${type}/entity/${entityId}/latest`, method: 'GET', signal
    },
      options);
    }
  

export const getGetLatestActiveTermsAndConditionsByTypeAndEntityIdQueryKey = (type?: TermsAndConditionsType,
    entityId?: string,) => {
    return [`/api/terms-and-conditions/type/${type}/entity/${entityId}/latest`] as const;
    }

    
export const getGetLatestActiveTermsAndConditionsByTypeAndEntityIdQueryOptions = <TData = Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError = unknown>(type: TermsAndConditionsType,
    entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetLatestActiveTermsAndConditionsByTypeAndEntityIdQueryKey(type,entityId);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>> = ({ signal }) => getLatestActiveTermsAndConditionsByTypeAndEntityId(type,entityId, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(type && entityId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetLatestActiveTermsAndConditionsByTypeAndEntityIdQueryResult = NonNullable<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>>
export type GetLatestActiveTermsAndConditionsByTypeAndEntityIdQueryError = unknown


export function useGetLatestActiveTermsAndConditionsByTypeAndEntityId<TData = Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError = unknown>(
 type: TermsAndConditionsType,
    entityId: string, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>,
          TError,
          Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLatestActiveTermsAndConditionsByTypeAndEntityId<TData = Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError = unknown>(
 type: TermsAndConditionsType,
    entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>,
          TError,
          Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetLatestActiveTermsAndConditionsByTypeAndEntityId<TData = Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError = unknown>(
 type: TermsAndConditionsType,
    entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetLatestActiveTermsAndConditionsByTypeAndEntityId<TData = Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError = unknown>(
 type: TermsAndConditionsType,
    entityId: string, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getLatestActiveTermsAndConditionsByTypeAndEntityId>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetLatestActiveTermsAndConditionsByTypeAndEntityIdQueryOptions(type,entityId,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getActiveTermsAndConditionsByType = (
    type: TermsAndConditionsType,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO[]>(
      {url: `/api/terms-and-conditions/type/${type}/active`, method: 'GET', signal
    },
      options);
    }
  

export const getGetActiveTermsAndConditionsByTypeQueryKey = (type?: TermsAndConditionsType,) => {
    return [`/api/terms-and-conditions/type/${type}/active`] as const;
    }

    
export const getGetActiveTermsAndConditionsByTypeQueryOptions = <TData = Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError = unknown>(type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveTermsAndConditionsByTypeQueryKey(type);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>> = ({ signal }) => getActiveTermsAndConditionsByType(type, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(type), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActiveTermsAndConditionsByTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>>
export type GetActiveTermsAndConditionsByTypeQueryError = unknown


export function useGetActiveTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>,
          TError,
          Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>,
          TError,
          Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetActiveTermsAndConditionsByType<TData = Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError = unknown>(
 type: TermsAndConditionsType, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveTermsAndConditionsByType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActiveTermsAndConditionsByTypeQueryOptions(type,options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getAllActiveTermsAndConditions = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<TermsAndConditionsDTO[]>(
      {url: `/api/terms-and-conditions/active`, method: 'GET', signal
    },
      options);
    }
  

export const getGetAllActiveTermsAndConditionsQueryKey = () => {
    return [`/api/terms-and-conditions/active`] as const;
    }

    
export const getGetAllActiveTermsAndConditionsQueryOptions = <TData = Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllActiveTermsAndConditionsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>> = ({ signal }) => getAllActiveTermsAndConditions(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllActiveTermsAndConditionsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>>
export type GetAllActiveTermsAndConditionsQueryError = unknown


export function useGetAllActiveTermsAndConditions<TData = Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>,
          TError,
          Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActiveTermsAndConditions<TData = Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>,
          TError,
          Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllActiveTermsAndConditions<TData = Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useGetAllActiveTermsAndConditions<TData = Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllActiveTermsAndConditions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllActiveTermsAndConditionsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



